import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { wildcardRegexp } from '@mssgme/shared';
import { getUser } from './userSelectors';

export const getConversation = (state, contactId) => state.conversations.list.byContactId[contactId];

export const getConversationItems = createSelector(
    (state) => state.conversations.list.ids,
    (state) => state.conversations.list.byContactId,
    (ids, byContactId) => ids.map((id) => byContactId[id])
);

export const getConversationMessages = (state, contactId) => state.conversations.messages[contactId];

const isStatusMatched = (item, status) => item.status === status;

const isAssignMatched = (item, assign, userId) => {
    switch (assign) {
        case 'all':
            return true;
        case 'unassigned':
            return isEmpty(item.assignTo);
        case 'my':
            return item.assignTo === userId;
        default:
            return assign === item.assignTo;
    }
};

const isNameMatched = (item, searchValue) => {
    const name = searchValue.trim();
    if (name.length === 0) return true;
    const regex = wildcardRegexp(name);
    return regex.test(item.contact.name);
};

export const getConversationsFilter = (state) => state.ui.conversationsFilter;

export const getFilteredConversations = createSelector(
    getConversationItems,
    getConversationsFilter,
    getUser,
    (conversations, filter, currentUser) =>
        conversations.filter(
            (item) =>
                isStatusMatched(item, filter.status) &&
                isAssignMatched(item, filter.assign, currentUser._id) &&
                isNameMatched(item, filter.searchValue)
        )
);

export const getFilteredAndSortedConversations = createSelector(
    getFilteredConversations,
    getConversationsFilter,
    (conversations, filter) =>
        conversations.sort((a, b) => {
            const op = filter.showNewFirst ? 1 : -1;
            if (a.lastMessageReceived > b.lastMessageReceived) return -1 * op;
            if (a.lastMessageReceived < b.lastMessageReceived) return 1 * op;
            return 0;
        })
);

export const countUnreadConversations = createSelector(
    (state) => state.conversations.unread,
    (unread) => {
        let count = 0;

        for (const value of Object.values(unread)) {
            if (value > 0) {
                count++;
            }
        }

        return count;
    }
);
